import {
  getFirestore,
  collection,
  getDocs,
  query,
  orderBy,
  startAfter,
  limit,
  where,
} from "firebase/firestore";

const db = getFirestore();

export const getCollection = async ({
  collectionName,
  orgId,
  filterField,
  filterValue,
  lastDocument,
  pageSize,
  orderByField,
  orderDirection = "asc",
  filters = [],
}) => {
  if (!collectionName) {
    throw new Error("collectionName est requis.");
  }

  try {
    const collectionRef = collection(db, collectionName);
    const queryConstraints = [];

    if (orgId !== undefined && filterField !== "orgId") {
      queryConstraints.push(where("orgId", "==", orgId));
    }

    if (filterField && filterValue !== undefined) {
      queryConstraints.push(where(filterField, "==", filterValue));
    }

    filters.forEach(({ field, operator = "==", value }) => {
      if (field && value !== undefined && value !== null && value !== "") {
        queryConstraints.push(where(field, operator, value));
      }
    });

    if (orderByField) {
      queryConstraints.push(orderBy(orderByField, orderDirection));
    }

    if (lastDocument) {
      queryConstraints.push(startAfter(lastDocument));
    }

    if (pageSize) {
      queryConstraints.push(limit(pageSize));
    }

    const q = query(collectionRef, ...queryConstraints);
    const querySnapshot = await getDocs(q);

    const data = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    const lastDoc = querySnapshot.docs.at(-1) || null;

    return { data, lastDoc };
  } catch (error) {
    console.error("Erreur lors de la récupération des données :", error);
    throw error;
  }
};
